<div class="impersonation-bar" [attr.data-cy]="testId()">
  <div class="impersonation-bar__info">
    <i class="impersonation-bar__eye uil uil-eye" aria-hidden="true"></i>
    <span class="impersonation-bar__label">Visualizando como:</span>
    <span class="impersonation-bar__name">{{ impersonatedName() }}</span>
    @if (profileLabel()) {
      <span class="impersonation-bar__sep" aria-hidden="true">·</span>
      <span class="impersonation-bar__meta">{{ profileLabel() }}</span>
    }
    @if (context()) {
      <span class="impersonation-bar__sep" aria-hidden="true">·</span>
      <span class="impersonation-bar__meta">{{ context() }}</span>
    }
  </div>

  <button
    type="button"
    class="impersonation-bar__exit"
    [attr.data-cy]="exitTestId()"
    (click)="onExit()">
    <i class="uil uil-arrow-left" aria-hidden="true"></i>
    <span class="impersonation-bar__exit-label">Voltar para {{ adminName() }}</span>
  </button>
</div>
